export default __webpack_public_path__ + "static/web-site-bottom-5a1093ea26849cdbe28b5be69ffb592c.jpg";